// Formatters partagés par les 4 tableaux drilldown.

export function formatDuration(seconds: number | null | undefined): string {
  if (!seconds) return ''
  const m = Math.floor(seconds / 60)
  const s = seconds % 60
  if (m === 0) return `${s}s`
  if (s === 0) return `${m}m`
  return `${m}m ${String(s).padStart(2, '0')}`
}

export function formatDateTime(iso: string | null | undefined, locale: string): string {
  if (!iso) return ''
  const d = new Date(iso)
  return d.toLocaleString(locale === 'fr' ? 'fr-CA' : 'en-CA', {
    day: '2-digit',
    month: 'short',
    hour: '2-digit',
    minute: '2-digit',
  })
}

export function formatRelativeDate(iso: string | null | undefined, locale: string): string {
  if (!iso) return ''
  const d = new Date(iso)
  return d.toLocaleDateString(locale === 'fr' ? 'fr-CA' : 'en-CA', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  })
}

// Pour les from_number stockés sous "client:agent_X_Y", affiche un libellé propre.
export function displayPhone(value: string | null | undefined, fallback = ''): string {
  if (!value) return fallback
  if (value.startsWith('client:agent_')) return 'Appel web'
  return value
}

/** Pretty-print un numéro E.164 en format canadien/US : +14389298446 → +1 (438) 929-8446 */
export function formatPhoneNumber(value: string | null | undefined): string {
  if (!value) return ''
  if (value.startsWith('client:agent_')) return 'Appel web'
  const digits = value.replace(/[^\d+]/g, '')
  // Format NANP : +1XXXXXXXXXX (11 chars avec +)
  if (digits.length === 12 && digits.startsWith('+1')) {
    const area = digits.slice(2, 5)
    const prefix = digits.slice(5, 8)
    const line = digits.slice(8, 12)
    return `+1 (${area}) ${prefix}-${line}`
  }
  return value
}
